import { render, staticRenderFns } from "./CornersAndGoalsPerMinute.vue?vue&type=template&id=6a890400&scoped=true&"
import script from "./CornersAndGoalsPerMinute.vue?vue&type=script&lang=js&"
export * from "./CornersAndGoalsPerMinute.vue?vue&type=script&lang=js&"
import style0 from "./CornersAndGoalsPerMinute.vue?vue&type=style&index=0&id=6a890400&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a890400",
  null
  
)

export default component.exports